import { useI18n } from '@runtime/core/i18n/i18n'
import homeTilePlaySrc from '@studio/routes/hub/components/assets/home-tile-play.png'

import styles from './HubAppHomeButton.module.scss'

type HubAppHomeButtonProps = {
  onClick: () => void
}

export default function HubAppHomeButton({ onClick }: HubAppHomeButtonProps) {
  const { t } = useI18n()

  return (
    <button
      type="button"
      className={styles.homeButton}
      onClick={onClick}
      aria-label={t('common.goHome')}
      title={t('common.goHome')}
      data-testid="hub-app-home-button"
    >
      <img className={styles.homeImage} src={homeTilePlaySrc} alt="" />
      <span className={styles.homeShade} aria-hidden />
      <span className={styles.homeLabel}>{t('common.home')}</span>
    </button>
  )
}
